import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";
import LatLong from "./LatLong";

@usingJsonToModelConvertor
export default class DeliveryAddress extends Model{

    @fromJsonObject({key: 'id'})
    public id! : number;

    @fromJsonObject({key: 'address'})
    public address! : string;

    @fromJsonObject({key: 'phone'})
    public phone! : string;

    @fromJsonObject({key: 'client_name'})
    public clientName! : string;

    @fromJsonObject({key: 'title'})
    public title! : string;

    @fromJsonObject({key: 'latlong', modelClass: LatLong, isArray: false})
    public latlong! : LatLong;

}